import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 0.75rem 0;
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(8, 38, 95, 0.08);
  backdrop-filter: blur(18px);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const HeaderBar = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  min-height: 72px;
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;

export const LogoImage = styled("img")`
  width: 148px;
  height: 70px;
  object-fit: contain;
  object-position: left center;
  display: block;

  @media only screen and (max-width: 768px) {
    width: 118px;
    height: 58px;
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;
  

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(8, 38, 95, 0.14);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;

  @media only screen and (max-width: 890px) {
    display: flex;
  }

  display: none;

  svg {
    color: #08265f;
  }
`;

export const NotHidden = styled("div")`
  nav {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 0.98rem;
  color: #08265f;
  transition: color 0.2s ease-in;
  margin: 0;

  a {
    color: #29405f;
    font-weight: 700;
  }

  a:hover {
    color: #1167ff;
  }

  @media only screen and (max-width: 768px) {
    display: block;
    margin: 1.25rem 0;
    text-align: start;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #1167ff;
  }
`;
